export default "__VITE_ASSET__CXBaLTQU__"